import { render, staticRenderFns } from "./GenderInput.vue?vue&type=template&id=59bc550e&scoped=true&"
import script from "./GenderInput.vue?vue&type=script&lang=js&"
export * from "./GenderInput.vue?vue&type=script&lang=js&"
import style0 from "./GenderInput.vue?vue&type=style&index=0&id=59bc550e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bc550e",
  null
  
)

component.options.__file = "GenderInput.vue"
export default component.exports